'use client';
import dynamic from 'next/dynamic';
import React from 'react';
import DynamicComponent from '@repo/ui/src/components/DynamicComponent';
import { ModalID } from '@repo/ui/src/modules/UI';
import { useUI } from '@repo/ui/src/modules/UI/hooks/useUI';

const componentTypes = {
  [ModalID.languageSelector]: dynamic(
    () => import('@repo/ui/src/components/LanguageSelector/LanguageSelectorModal'),
  ),
  [ModalID.video]: dynamic(() => import('@components/Modals/components/VideoModal')),
};

const Modals = () => {
  const { openModalIds } = useUI();
  return (
    <>
      {openModalIds.map((id: string) => (
        <DynamicComponent key={id} _componentTypes={componentTypes} id={id} _field="id" />
      ))}
    </>
  );
};

export default Modals;
